export default "__VITE_ASSET__CwU0OkQ5__"